export const messages = {
  en: {
    printQuestionAnswerDetail: {
      table: {
        title: 'Title',
        type: 'Type',
        options: 'Options',
        choices: 'Choices'
      },
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      shortAnswer: 'Short Answer',
      total: 'Total',
      submitted: 'Submitted',
      people: 'people',
      print: 'Print',
      cancel: 'Cancel'
    }
  },
  zh: {
    printQuestionAnswerDetail: {
      table: {
        title: '名称',
        type: '类型',
        options: '选项',
        choices: '选择'
      },
      singleChoice: '单选',
      multipleChoice: '多选',
      shortAnswer: '简答',
      total: '总数',
      submitted: '已提交',
      people: '人',
      print: '打印',
      cancel: '取消'
    }
  },
  'zh-TW': {
    printQuestionAnswerDetail: {
      table: {
        title: '名稱',
        type: '類型',
        options: '選項',
        choices: '選擇'
      },
      singleChoice: '單選',
      multipleChoice: '多選',
      shortAnswer: '簡答',
      total: '總數',
      submitted: '已提交',
      people: '人',
      print: '打印',
      cancel: '取消'
    }
  }
};